const caches = {}

const getPageCache = (pathname, stringifiedFilter) => {
  const pageState = caches[pathname]

  if (!pageState) return null

  if (pageState.stringifiedFilter !== stringifiedFilter) return null

  const data =
    Object.values(pageState.dataObject)

  return { ...pageState, data }
}

const clearPageCache = (pathname) => {
  delete caches[pathname]
}

const updateCachePageData = (pathname, updatedData) => {
  const cache = caches[pathname]

  if (!cache) return

  cache.dataObject[updatedData._id] = updatedData
}

const deleteCachePageData = (pathname, dataId) => {
  const cache = caches[pathname]

  if (!cache) return

  delete cache.dataObject[dataId]
}

const cachePageData = (
  pathname = "",
  stringifiedFilter = "",
  data = [],
  skip = 0,
  hasMore = false,
  pagination = 0
) => {
  const dataObject = {}

  data.forEach(item => dataObject[item._id] = item)

  caches[pathname] = {
    dataObject,
    skip,
    pagination,
    hasMore,
    stringifiedFilter,
    scorllTop: 0,
    scrollLeft: 0
  }
}

const restoreScroll = (pathname, element) => {
  setTimeout(() => {
    const state =
      caches[pathname]

    if (!state) return

    element?.scrollTo({
      top: state.scorllTop,
      left: state.scorllLeft,
      behavior: "instant"
    })
  }, 10)
}

const saveScroll = (pathname, element) => {
  const scorllTop =
    element.pageYOffset ||
    element.scorllTop ||
    0

  const scrollLeft =
    element.pageXOffset ||
    element.scorllLeft ||
    0

  caches[pathname] = {
    ...caches[pathname],
    scorllTop,
    scrollLeft
  }
}

const pageCache = {
  restoreScroll,
  cachePageData,
  getPageCache,
  saveScroll,
  clearPageCache,
  updateCachePageData,
  deleteCachePageData
}

export default pageCache